import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-settings-maintainance',
  templateUrl: './settings-maintainance.component.html',
  styleUrls: ['./settings-maintainance.component.scss']
})
export class SettingsMaintainanceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
